import React, { useCallback, useEffect, useState } from 'react';

import loadingSpinner from '@images/spinners/double-ring-200px.gif';
import Sharing from './forms/Sharing';
import Newsletter from './forms/Newsletter';
import StencilBuilderSteps from './StencilBuillderSteps';
import Email from './forms/Email';
import Submit from './forms/Submit';
import useStencilPreviewer from '../../hooks/useStencilPreviewer';
import { useDispatch } from 'react-redux';
import { setRemotePreviewImageUrl } from '../../actions/stencils/editor';

function Preview({ onPreviewSuccess }: { onPreviewSuccess: () => void }) {
  const dispatch = useDispatch();
  const previewer = useStencilPreviewer();
  const [localPreviewUrl, setLocalPreviewUrl] = useState(null);

  const handlePreviewSuccess = useCallback(
    (url) => {
      setLocalPreviewUrl(url);
      dispatch(setRemotePreviewImageUrl(url));
      onPreviewSuccess();
    },
    [dispatch, onPreviewSuccess]
  );

  const handlePreviewFailed = useCallback(() => {}, []);

  useEffect(() => {
    previewer.start(handlePreviewSuccess, handlePreviewFailed);

    return () => previewer.stop();
  }, [handlePreviewFailed, handlePreviewSuccess, previewer]);

  return (
    <div className="stencil-preview-image-container">
      {localPreviewUrl ? (
        <img
          className="stencil-preview-image"
          src={localPreviewUrl}
          alt="Preview of your submission"
        />
      ) : (
        <div className="stencil-preview-loading">
          <img src={loadingSpinner} alt={''} />
          <p>Generating preview, please wait</p>
        </div>
      )}
    </div>
  );
}

function Form() {
  return (
    <div className="stencil-form">
      <Email />
      <Sharing />
      <Newsletter />
    </div>
  );
}

function PreviewNavigation({
  enableSubmit,
  onPreviousStep
}: {
  enableSubmit: boolean;
  onPreviousStep: () => void;
}) {
  return (
    <div className="stencil-navigation">
      <button
        className="stencil-navigation-link--back"
        type="button"
        onClick={onPreviousStep}
      >
        {'< Previous'}
      </button>
      <Submit enabled={enableSubmit} />
    </div>
  );
}

function StencilFormPreview({
  onPreviousStep
}: {
  onPreviousStep: () => void;
}) {
  const [isPreviewSuccessful, setIsPreviewSuccessful] = useState(false);

  const handleSuccessfulPreview = useCallback(() => {
    setIsPreviewSuccessful(true);
  }, []);

  return (
    <div className="stencil-preview stencil-form-page">
      <StencilBuilderSteps />
      <Preview onPreviewSuccess={handleSuccessfulPreview} />
      <Form />
      <PreviewNavigation
        onPreviousStep={onPreviousStep}
        enableSubmit={isPreviewSuccessful}
      />
    </div>
  );
}

export default StencilFormPreview;
